module.exports = __webpack_public_path__ + "images/canonical-card/confused-taco.1d592218314218997168.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/confused-taco.svg
// module id = zs/n
// module chunks = 0